export default {"src":"/_next/static/media/arrow_next_gallery_slide_desktop.f6c184d3.svg","height":14,"width":9};